import { render, staticRenderFns } from "./PatientEducation.vue?vue&type=template&id=38e84ea4"
import script from "./PatientEducation.vue?vue&type=script&lang=js"
export * from "./PatientEducation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38e84ea4')) {
      api.createRecord('38e84ea4', component.options)
    } else {
      api.reload('38e84ea4', component.options)
    }
    module.hot.accept("./PatientEducation.vue?vue&type=template&id=38e84ea4", function () {
      api.rerender('38e84ea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/patient/education/PatientEducation.vue"
export default component.exports